import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    tag: "Recommended",
    tagColor: "bg-[#1A365D] text-white",
    speed: "2–9",
    unit: "days",
    label: "Fast Passport Center Expedited",
    highlight: true,
    features: [
      "No appointment needed — we handle agency submission",
      "Dedicated agent reviews your application for errors",
      "Reserved courier slots at U.S. passport agencies",
      "Daily status updates via phone or email",
      "Not affected by government shutdowns",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
    ],
  },
  {
    tag: "Standard Expedited",
    tagColor: "bg-green-50 text-green-700",
    speed: "3–5",
    unit: "weeks",
    label: "Post Office Expedited",
    smartSaver: true,
    features: [
      "Available at Jackson post office",
      "You pay government + post office fees",
      "You handle all paperwork yourself",
      "No dedicated support — DIY process",
      "Mailing delays can add 1–2 weeks",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
    ],
    highlight: false,
  },
  {
    tag: "Routine",
    tagColor: "bg-gray-100 text-gray-500",
    speed: "6–11",
    unit: "weeks",
    label: "Routine Post Office",
    muted: true,
    features: [
      "Cheapest option — government fee only",
      "Must visit post office in person",
      "No tracking or status updates available",
      "Longest wait — not recommended for travel",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
    ],
    highlight: false,
  },
  {
    tag: "Emergency",
    tagColor: "bg-red-50 text-red-600",
    speed: "24h",
    unit: "or less",
    label: "Life-or-Death Emergency",
    emergency: true,
    features: [
      "Must have documented emergency & travel within 72 hours",
      "Appointment required at Salt Lake City or Denver Regional Agency",
      "You apply in person — no courier service",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
    ],
    highlight: false,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Jackson"
      headingExtra="WY"
      introText="Jackson passport applicants face the Wyoming reality: zero passport agencies in the state. For emergency processing, the closest agency is Denver at ~500 miles or Salt Lake City at ~280 miles through mountain terrain. Here's how the options compare — and why a courier makes sense when agency access is this remote."
      options={options}
      emergencyDescription="Strictly for documented life-or-death emergencies. Wyoming has no passport agency. Closest is Salt Lake City — ~280 miles via US-89/I-80 through mountain passes, 4.5+ hours in good weather. Denver is ~500 miles, 7+ hours. Winter conditions on Teton Pass and I-80 can close roads entirely, making emergency agency visits highly unreliable."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. Wyoming has no passport agency — nearest agencies are in Salt Lake City and Denver."
    />
  );
}